export const CONTACT_INFO = [
    {
        name: 'Kethireddy Pradeep CHBS',
        title: 'Platform Manager',
        email: 'pradeep.kethireddy@syngenta.com',
    },
    {
        name: 'Caramatti Irene CHBS',
        title: 'Environmental Data and Platform Specialist',
        email: 'Irene.Caramatti@syngenta.com',
    },
] as const;

export const MAX_FILES = 5;
export const MAX_FILE_SIZE_MB = 5;

export const ALLOWED_TYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/webp',
];
